import {useRef} from 'react';
import {useStore} from 'react-redux';

import {useUpdateWorkshopInterestVehicleInformationMutation} from '@dms/api/workshop';
import {handleApiError} from '@dms/shared';

import {getSafely} from 'shared/web';

import {VehicleInformationFormType} from '../types';
import {transformFormToVehicleInformation} from '../utils/transformCustomerInquiry';

export function useVehicleInformationUpdate(interestId: string) {
  const store = useStore();
  const pendingValuesRef = useRef<VehicleInformationFormType | null>(null);

  const cacheKey = `update-vehicle-information-${interestId}`;
  const [updateVehicleInformation] = useUpdateWorkshopInterestVehicleInformationMutation({
    fixedCacheKey: cacheKey,
  });

  const isUpdateInProgress = () => {
    const state = store.getState() as {
      rtk_omneticApi?: {mutations?: Record<string, {status?: string}>};
    };
    const mutations = state.rtk_omneticApi?.mutations;
    return getSafely(mutations, cacheKey)?.status === 'pending';
  };

  const onVehicleInformationUpdate = (values: VehicleInformationFormType) => {
    if (isUpdateInProgress()) {
      pendingValuesRef.current = {...pendingValuesRef.current, ...values};
      return;
    }

    updateVehicleInformation({
      interestId,
      updateVehicleInformationRequestBody: transformFormToVehicleInformation(values),
    })
      .unwrap()
      .then(() => {
        if (pendingValuesRef.current) {
          const pending = pendingValuesRef.current;
          pendingValuesRef.current = null;
          onVehicleInformationUpdate(pending);
        }
      })
      .catch(handleApiError);
  };

  return {onVehicleInformationUpdate};
}
